import { useTranslations } from 'next-intl';
import {
  CatButton,
  CatIconArrowForward,
  CatIconChevronRight
} from 'components/blocks-components';
import { handleRedirectUrlToAlp } from '../../utils';
import { ServiceInsightViewDetailsProps } from '../../types';
import styles from '../service-insight-card.module.scss';

export const ServiceInsightViewDetails = ({
  serviceInsights,
  isDesktop
}: ServiceInsightViewDetailsProps) => {
  const t = useTranslations();
  const handleClick = () => {
    handleRedirectUrlToAlp({
      serviceId: serviceInsights.payloadId,
      equipmentInfo: serviceInsights.equipmentInfo
    });
  };
  return (
    <>
      {isDesktop ? (
        <CatButton
          variant="ghost"
          size="sm"
          aria-label={t('VIEW_DETAILS')}
          onClick={handleClick}
        >
          {t('VIEW_DETAILS')}
          <CatIconArrowForward slot="after" />
        </CatButton>
      ) : (
        <div className={styles['service_card_Icon']}>
          <CatIconChevronRight />
        </div>
      )}
    </>
  );
};
